import { useMsal } from '@azure/msal-react';
import { useQuery } from '@tanstack/react-query';
import { apiFetch, type Me } from './client';

export function useMe() {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['me'],
    queryFn: () => apiFetch<Me>(instance, '/api/me'),
  });
}
